/**
 * Ordenação padrão de perfis/nomes em todo o sistema.
 *
 * Regra: Agrupar por qualificação na ordem:
 *   1. Sócio Gestor + Sócio
 *   2. Associado
 *   3. Controller
 *   4. Estagiário
 *   5. Colaborador
 * Dentro de cada grupo, ordenar alfabeticamente (pt-BR).
 */

export const QUAL_ORDER: Record<string, number> = {
  socio_gestor: 0,
  socio: 0,
  associado: 1,
  controller: 2,
  estagiario: 3,
  colaborador: 4,
  escritorio: 99,
  externo: 99,
};

export { qualificationPluralLabel as QUAL_LABELS } from "./genderedLabels";
export { getQualificationLabel } from "./genderedLabels";

/**
 * Comparador genérico para ordenar perfis por qualificação + nome.
 * Aceita qualquer objeto que tenha { qualificacao: string; nome: string }.
 */
export function compareProfiles<T extends { qualificacao: string; nome: string }>(a: T, b: T): number {
  const qa = QUAL_ORDER[a.qualificacao] ?? 98;
  const qb = QUAL_ORDER[b.qualificacao] ?? 98;
  if (qa !== qb) return qa - qb;
  return a.nome.localeCompare(b.nome, "pt-BR");
}

/**
 * Ordena um array de perfis in-place e retorna o array.
 */
export function sortProfiles<T extends { qualificacao: string; nome: string }>(profiles: T[]): T[] {
  return [...profiles].sort(compareProfiles);
}
